import {
  NBS_API_SET_NEW_PASSWORD_REQUEST,
  NBS_API_SET_NEW_PASSWORD_SUCCESS,
  NBS_API_SET_NEW_PASSWORD_FAILURE
} from '../../constants/actions';
import nbsApi from '../../assets/helpers/nbsApi';
import strings from '../../assets/localization';

function nbsApiSetNewPasswordRequest () {
  return { type: NBS_API_SET_NEW_PASSWORD_REQUEST };
}
function nbsApiSetNewPasswordSuccess (response) {
  return {
    type: NBS_API_SET_NEW_PASSWORD_SUCCESS,
    response
  };
}
function nbsApiSetNewPasswordFailure (error) {
  return {
    type: NBS_API_SET_NEW_PASSWORD_FAILURE,
    error: error.cause || error
  };
}
export function nbsApiSetNewPassword (data) {
  const url = 'setNewPassword';
  if (!data.language && strings.getLanguage()) {
    data.language = strings.getLanguage();
  }
  return dispatch => {
    dispatch(nbsApiSetNewPasswordRequest());
    return nbsApi(url, data)
      .then(response => dispatch(nbsApiSetNewPasswordSuccess(response)))
      .catch(error => dispatch(nbsApiSetNewPasswordFailure(error)));
  };
}
